import {Button, Form, Input, message, Spin} from "antd";
import styled from "styled-components";
import {useMutation, useQuery} from "react-query";
import {adminSetPassword, checkInviteKey} from "../../api/User";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 181px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PageContent = styled.div`
  width: 100%;
  max-width: 600px;
`;

const PageTitle = styled.div`
  font-size: 32px;
  color: #fff;
  margin-bottom: 50px;
`;

export const AdminSetPassword = () => {
    const navigate = useNavigate()
    const url = new URL(window.location.href)
    const key = url.searchParams.get('user_invite_key')

    const {data: checkInviteData, isLoading: checkInviteLoading } = useQuery({
        queryFn: () => {
            return checkInviteKey(key)
        }
    })
    const {mutateAsync: setPassword} = useMutation(adminSetPassword)
    const handleFormFinish = async ({password, confirmPassword}) => {
        const res = await setPassword({
            key,
            password,
            confirmPassword
        })

        if (+res?.code === 10000) {
            message.success('Set password successful, please login')
            setTimeout(() => {
                navigate('/login', {
                    replace: true
                });
            }, 1000)
        }
    }

    if (checkInviteLoading) return <Spin />

    if (!checkInviteData.data.is_exists) {
        return <h2>Invite key is invalid</h2>
    }

    return (
        <>
            <PageContainer>
                <PageContent>
                    <PageTitle>Set Password</PageTitle>
                    <Form
                        layout={'vertical'}
                        autoComplete="off"
                        requiredMark={false}
                        onFinish={handleFormFinish}
                    >
                        <Form.Item
                            name={'password'}
                            label="Password"
                            rules={[{ required: true, message: 'Please input your password!' }]}
                        >
                            <Input type={'password'} className="reset-password-input" />
                        </Form.Item>
                        <Form.Item
                            name={'confirmPassword'}
                            label="Confirm Password"
                            dependencies={['password']}
                            rules={[
                                { required: true, message: 'Please input your password!' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }

                                        return Promise.reject(
                                            new Error(
                                                'The two passwords that you entered do not match!'
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input type={'password'} className="reset-password-input" />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type={'text'}
                                htmlType={'submit'}
                                className="reset-password-btn"
                            >
                                Reset
                            </Button>
                        </Form.Item>
                    </Form>
                </PageContent>
            </PageContainer>
        </>
    )
}